<!-- MODAL darDeBaja -->
<div mdbModal #darDeBaja="mdb-modal" class="modal fade" id="basicExample" tabindex="-1" role="dialog"
    aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ backdrop: true, ignoreBackdropClick: true }">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title w-100 text-left" id="myModalLabel">
                    Inactivar
                </h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="darDeBaja.hide()">
                    <span aria-hidden="true">×</span>
                </button>
            </div>
            <form autocomplete="off" [formGroup]="formBaja">
                <div class="modal-body">

                  <h5 class="mt-2" *ngIf="showProveedor === true">
                    <mdb-checkbox [checked]="false" formControlName="generar_guia">
                      <span style="font-size: 1rem">Generar guia</span>
                    </mdb-checkbox>
                  </h5>
                    <div class="row">
                        <div class="col" style="max-width: 300px" *ngIf="showProveedor === true">
                            <div class="md-form mb-0">
                                <mdb-select [options]="optionsTipoDoc" [multiple]="false" [filterEnabled]="true"
                                    [highlightFirst]="false" placeholder="Seleccionar tipo" formControlName="tipoDte">
                                </mdb-select>
                                <label>Tipo de documento</label>
                                <div *ngIf="
                                    formBaja.get('tipoDte').invalid &&
                                    (formBaja.get('tipoDte').dirty ||
                                    formBaja.get('tipoDte').touched)
                                    ">
                                    <mdb-error *ngIf="formBaja.get('tipoDte').hasError('required')">
                                        Ingrese tipo documento
                                    </mdb-error>
                                </div>
                            </div>
                        </div>
                        <div class="col" style="max-width: 300px" *ngIf="showProveedor === true">
                            <div class="md-form">
                                <mdb-select [options]="optionsProveedor" [multiple]="false" [filterEnabled]="true"
                                    [highlightFirst]="false" placeholder="Seleccionar Proveedor"
                                    formControlName="proveedor"></mdb-select>
                                <label>Proveedor</label>
                                <div *ngIf="
                              formBaja.get('proveedor').invalid &&
                              (formBaja.get('proveedor').dirty ||
                              formBaja.get('proveedor').touched)
                              ">
                                    <mdb-error *ngIf="formBaja.get('proveedor').hasError('required')">
                                        Ingrese proveedor
                                    </mdb-error>
                                </div>
                            </div>
                        </div>
                        <div class="col" style="max-width: 300px" *ngIf="showProveedor === true">
                            <div class="md-form mb-0" *ngIf="formBaja.get('tipoDte').value !== 52 || formBaja.get('generar_guia').value === false">
                                <input value="" type="text" id="ndoc" class="form-control" placeholder="N° Documento"
                                    #ndoc formControlName="nroDoc" onlyNumbers />
                                <label for="ndoc">N° Documento</label>
                                <div *ngIf="
                                    formBaja.get('nroDoc').invalid &&
                                    (formBaja.get('nroDoc').dirty ||
                                    formBaja.get('nroDoc').touched)
                                    ">
                                    <mdb-error *ngIf="formBaja.get('nroDoc').hasError('required')">
                                        Ingrese nro. documento
                                    </mdb-error>
                                </div>
                            </div>
                            <div class="md-form" *ngIf="formBaja.get('tipoDte').value === 52 && formBaja.get('generar_guia').value === true">
                                <input value="" type="text" id="descripcion" class="form-control" maxlength="100"
                                    placeholder="Descripción" #descripcion formControlName="descripcion" />
                                <label for="descripcion">Descripción</label>
                                <div *ngIf="formBaja.get('tipoDte').value === 52 &&
                                formBaja.get('descripcion').invalid &&
                                (formBaja.get('descripcion').dirty ||
                                formBaja.get('descripcion').touched)">
                                  <mdb-error *ngIf="formBaja.get('descripcion').hasError('required')">
                                    Ingrese Descripción
                                  </mdb-error>
                                </div>
                            </div>
                        </div>
                        <div class="col" style="max-width: 200px" *ngIf="formBaja.get('tipoDte').value !== 52 || formBaja.get('generar_guia').value === false">
                            <div class="md-form mb-0">
                                <label for="fechaBaja">Fecha</label>
                                <mdb-date-picker #dtFechaBaja [inline]="true" name="fechaDesde" [placeholder]="'Fecha'"
                                    required formControlName="fechaBaja">
                                </mdb-date-picker>
                                <div *ngIf="
                                    formBaja.get('fechaBaja').invalid &&
                                    (formBaja.get('fechaBaja').dirty ||
                                    formBaja.get('fechaBaja').touched)
                                    ">
                                    <mdb-error *ngIf="formBaja.get('fechaBaja').hasError('required')">
                                        Ingrese fechaBaja
                                    </mdb-error>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br>
                    <div class="row mt-2">
                        <div class="col">
                            <div class="md-form mb-0">
                                <input value="" type="text" id="observacion" class="form-control"
                                    placeholder="Observación..." required #observacion formControlName="observacion" maxlength="200"/>
                                <label for="observacion">Observación</label>
                                <div *ngIf="
                                    formBaja.get('observacion').invalid &&
                                    (formBaja.get('observacion').dirty ||
                                    formBaja.get('observacion').touched)
                                    ">
                                    <mdb-error *ngIf="formBaja.get('observacion').hasError('required')">
                                        Ingrese observación
                                    </mdb-error>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
            <div class="modal-footer justify-content-between">
                <button size="sm" type="button" class="btn btn-sm btn-default waves-light" data-dismiss="modal"
                    (click)="CloseInactivar()" mdbWavesEffect>
                    Cerrar
                </button>
                <button size="sm" type="button" class="btn btn-sm btn-secondary waves-light" mdbWavesEffect
                    (click)="guardar()">
                    Guardar
                </button>
            </div>
        </div>
    </div>
</div>
